import { BaseComponent, BElement } from "utils/base-component"
import {
  createPopperLite as createPopper,
  preventOverflow,
  flip,
  arrow,
  offset,
  Instance,
} from "@popperjs/core"

import "./buttons/button.scss"
import "./links/link.scss"
import "./tabs/tab.scss"

export class Buttons extends BaseComponent {
  static cssClass = "button"

  private buttons!: BElement[]
  private tooltip!: HTMLElement
  private popper!: Instance
  private title!: string

  init() {
    this.buttons = this.elements("button")!
    const mediaQuerySmall = window.matchMedia("(max-width: 900px)")

    this.buttons.forEach((button) => {
      if (mediaQuerySmall.matches) {
        button.element.addEventListener("touchstart", () => {
          this.show(button)

          setTimeout(() => this.hide(button), 500)
        })
      } else {
        button.element.addEventListener("mouseenter", (e) => {
          e.preventDefault()
          this.show(button)
        })

        button.element.addEventListener("mouseleave", (e) => {
          e.preventDefault()
          this.hide(button)
        })
      }
    })
  }

  private show(button: BElement) {
    this.renderTooltip(button.element)
    document.body.appendChild(this.tooltip)
    const el = button.element
    el.title = this.handleTitle(el.title)

    this.popper = createPopper(button.element, this.tooltip, {
      placement: "bottom-start",
      modifiers: [
        flip,
        arrow,
        offset,
        preventOverflow,
        {
          name: "preventOverflow",
          options: {
            padding: {
              top: 8,
              right: 8,
              bottom: 8,
              left: 8,
            },
          },
        },
        {
          name: "offset",
          options: {
            offset: [5, 5],
          },
        },
      ],
    })
  }

  private hide(button: BElement) {
    this.popper.destroy()
    this.popper = null as any

    document.body.removeChild(this.tooltip)
    const el = button.element
    el.title = this.handleTitle(el.title)
  }

  private renderTooltip(button: any) {
    this.tooltip = document.createElement("div")
    this.tooltip.classList.add(`${Buttons.cssClass}__tooltip-popup`)

    if (button.title) {
      const tooltipHeader = document.createElement("div")
      tooltipHeader.classList.add(`${Buttons.cssClass}__tooltip-popup-header`)
      this.tooltip.appendChild(tooltipHeader)
      tooltipHeader.innerText = button.title
    }

    const tooltipArrow = document.createElement("div")
    tooltipArrow.classList.add(`${Buttons.cssClass}__tooltip-popup-arrow`)
    tooltipArrow.setAttribute("data-popper-arrow", "")
    this.tooltip.appendChild(tooltipArrow)
  }

  private handleTitle(title: string) {
    if (title) {
      this.title = title
      return ""
    }
    return this.title
  }
}
